import { useCallback, useContext } from 'react';
import EditorContext from '../store/Editor.context';
import { resetSession } from '../store';
import FreePdf from '../services/FreePdf';

var useResetSession = function useResetSession() {
  var _useContext = useContext(EditorContext),
      dispatch = _useContext.dispatch;

  var reset = useCallback(function () {
    localStorage.clear();
    dispatch(resetSession);
    FreePdf.cancel();
  }, []);
  return reset;
};

export default useResetSession;